<template>
  <div class="parkinglist">
    <div class="list">
      <div class="item" v-for="item in list" :key="item.id">
        <img :src="item.logo" alt="" />
        <div>{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import parkinglist1 from "../../../../assets/programme/parkinglist1.png";
import parkinglist2 from "../../../../assets/programme/parkinglist2.png";
import parkinglist3 from "../../../../assets/programme/parkinglist3.png";
import parkinglist4 from "../../../../assets/programme/parkinglist4.png";

export default {
  setup() {
    return reactive({
      list: [
        {
          id: 1,
          title: "蓝卡高速道闸",
          logo: parkinglist1,
        },
        {
          id: 2,
          title: "曲臂道闸",
          logo: parkinglist2,
        },
        {
          id: 3,
          title: "AI无人值守停车场管理系统",
          logo: parkinglist3,
        },
        {
          id: 4,
          title: "AI无人值守停车场管理系统",
          logo: parkinglist4,
        },
      ],
    });
  },
};
</script>

<style scoped>
.parkinglist {
  width: 1180px;
  margin: 80px auto 0;
}
.list {
    display: flex;
    justify-content: space-between;
}
.list .item {
    text-align: center;
    overflow: hidden;
}
.list .item:hover img {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.list .item img {
    width: 280px;
}
.list .item div {
    font-size: 16px;
    color: #333;
    margin-top: 40px;
}
</style>
